import React from "react";
import * as styled from "../../components/subpageHeroArea/ApplicationSubpageStyled";
import GeneralBreadcrumb from "../breadcrumb/GeneralBreadcrumbComp";

type CareerApplicationProps = {
    title: string;
    text: string;
    breadcrumb?: any[];
}

const CareerApplication = (props: CareerApplicationProps) => {
    return (
        <styled.CareerApplicationContent>
            {(props.breadcrumb !== undefined) ? (
                <GeneralBreadcrumb items={props.breadcrumb} colorProps={false} margin={false}/>
                ) : null}
            <styled.CareerApplicationTitle>
                {props.title}
            </styled.CareerApplicationTitle>
            {/*<styled.CareerApplicationSubTitle>*/}
            {/*    Muhendis job title bir*/}
            {/*</styled.CareerApplicationSubTitle>*/}
            <styled.CareerApplicationDetail dangerouslySetInnerHTML={{__html: props.text}}>
            </styled.CareerApplicationDetail>
        </styled.CareerApplicationContent>
    )
}

export default CareerApplication;
